import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

type CookiesConsentContextType = {
  forcedOpen: boolean;
  setForcedOpen: (forcedShown: boolean) => void;
};

const CookiesConsentContext = createContext<CookiesConsentContextType>({
  forcedOpen: false,
  setForcedOpen: () => {},
});

export const CookiesConsentProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [forcedOpen, setForcedOpen] = useState(false);

  const value = useMemo(() => ({ forcedOpen, setForcedOpen }), [forcedOpen]);

  return (
    <CookiesConsentContext.Provider value={value}>
      {children}
    </CookiesConsentContext.Provider>
  );
};

export const useCookiesConsent = () => {
  return useContext(CookiesConsentContext);
};
